import { render, staticRenderFns } from "./Social.vue?vue&type=template&id=759995c4&scoped=true"
import script from "./Social.vue?vue&type=script&lang=js"
export * from "./Social.vue?vue&type=script&lang=js"
import style0 from "./Social.vue?vue&type=style&index=0&id=759995c4&prod&lang=stylus&scoped=true"
import style1 from "./Social.vue?vue&type=style&index=1&id=759995c4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759995c4",
  null
  
)

export default component.exports